﻿/// <reference types="@types/google.maps" />
import { Loader } from "@googlemaps/js-api-loader";

export type mapOptions = {
   mapSelector: string;
   mapApiKey: string;
   zoom?: number | null | undefined;
}

export const defaultMapPickerOptions: mapOptions = {
   mapSelector: '#map',
   mapApiKey: 'AIzaSyAYO57BjE9pDfwtykxUTlEPWTAsp59x1mA',
   zoom: 5
};

type mapLocation = {
   id: string;
   title: string;
   latlng: google.maps.LatLngLiteral;
}

const initMap = async (options: mapOptions) => {
   let map: google.maps.Map;
   let mapElement = document.querySelector(options.mapSelector) as HTMLElement;
   const loader = new Loader({
      apiKey: options.mapApiKey,
      version: "weekly",
      libraries: []
   });

   const locations = getLocations();
   if (locations.length === 0)
   {
      return;
   }

   const { Map } = await loader.importLibrary('maps');
   const { AdvancedMarkerElement } = await loader.importLibrary('marker');

   map = new Map(mapElement, {
      center: locations[0].latlng,
      mapId: "locations-map",
      zoom: options.zoom,
      mapTypeControl: false, // Disable map type control
      streetViewControl: false, // Disable street view control
      fullscreenControl: false, // Disable fullscreen control
   });

   for (var loc in locations) {

      new AdvancedMarkerElement({
         map: map,
         position: locations[loc].latlng,
         title: locations[loc].title
      });
   }


}

const getLocations = (): mapLocation[] => {
   const locations: mapLocation[] = [];
   const elems = document.querySelectorAll<HTMLElement>("[data-map-location='true']");
   elems.forEach((el, key) => {
      locations.push({ id: key.toString(), latlng: { lat: Number.parseFloat(el.dataset.lat ?? "0"), lng: Number.parseFloat(el.dataset.lng ?? "0") }, title: el.dataset.title ?? "" });
   })
   return locations;
}

initMap(defaultMapPickerOptions);